import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { MultiSelectComponent } from '../components/multi-select.component';
import { getOptions } from '../services/multi-select.service';

export function MultiSelectContainer ({ isDisabled, valueField, name, isRequired, list, label, className, onValueChangeCallback, labelField, value }: any) {

  const [
    options,
    setOptions
  ] = useState(getOptions({ list, valueField, labelField }));
  const [selected, setSelected] = useState<any>([]);
  const [query, setQuery] = useState('');
  const [open, setOpen] = useState(false);

  const handleButtonClick = () => {
    setOpen(!open);
  };
  const displaySelected = () => {
    if (selected && selected.length > 0) {
      return selected.map((data: any) => data.label) + ',';
    }
  };

  useEffect(
    () => {
      setOptions(getOptions({ list, valueField, labelField }))
    },
    [list]
  )
  useEffect(() => {
    if (value) {
      const mappedValue = value.map((val:any) => ({ 
        value: val, label: options.find((opt:any) => opt.value === val)?.label }));
      setSelected(mappedValue);
    }
  }, [value, options]);
  
  const filtered = query === '' ? options : options.filter((option:any) =>
    (query.includes(',') ? query.split(',').map(segment => segment.trim().toLowerCase()) : [query.trim().toLowerCase()])
      .every(segment => option?.label && option?.label.trim().toLowerCase().includes(segment))
  );
  const toggleSelection = (data: any) => {
    if (selected.find((p:any) => p.value === data.value)) {
      setSelected(selected.filter((p:any) => p.value !== data.value));
    } else {
      setSelected([...selected, data]);
    }
  };
  return (<MultiSelectComponent
      className={className}
      isDisabled={isDisabled}
      isRequired={isRequired}
      label={label}
      labelField={labelField}
      name={name}
      multiple
      setQuery={setQuery}
      displaySelected={displaySelected}
      query={query}
      selected={selected}
      toggleSelection={toggleSelection}
      setSelected={setSelected}
      onValueChange={(newValue:any) =>{ setSelected(newValue);
        onValueChangeCallback(newValue)
      }}
      onInputValueChange={({ target: { value } }:any) => {
        const lastCommaIndex = value.lastIndexOf(',');
        setQuery(lastCommaIndex !== -1 ? value.substring(lastCommaIndex + 1).trim().toLowerCase() : value.toLowerCase());
      }}
      options={options}
      valueField={valueField}
      handleButtonClick={handleButtonClick}
      filtered={filtered}
      open={open}
          />
  )
}